module.exports = __webpack_public_path__ + "b6005623ce941729ca9836f62334b1b5.png";